import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BlogService, BlogCategory, Language } from '@services/blog.service';
import { LanguageService } from '@services/language.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-blog-category-manage',
  templateUrl: './blog-category-manage.component.html',
    styleUrls: ['./blog-category-manage.css']

})
export class BlogCategoryManageComponent implements OnInit {
  categories: BlogCategory[] = [];
  categoryForm: FormGroup;
  languages: Language[] = [];
  submitted = false;
  editingCategoryId: number | null = null;
  loading = false;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private blogService: BlogService,
    private languageService: LanguageService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.loadLanguages();
    this.loadCategories();
  }

  initForm(): void {
    this.categoryForm = this.fb.group({
      name: ['', Validators.required],
      description: [''],
      slug: ['', Validators.required],
      languageId: ['', Validators.required],
      isActive: [true]
    });
  }

  loadLanguages(): void {
    this.languageService.all().subscribe({
      next: (languages) => {
        this.languages = languages;
        // Varsayılan olarak İngilizce seç
        const enLang = this.languages.find(l => l.code === 'en');
        if (enLang && !this.editingCategoryId) {
          this.categoryForm.patchValue({ languageId: enLang.id });
        }
      },
      error: () => {
        this.toastr.error('Diller yüklenirken hata oluştu', 'Hata');
      }
    });
  }

  loadCategories(): void {
    this.loading = true;
    this.blogService.getCategories().subscribe({
      next: (categories) => {
        this.categories = categories;
        this.loading = false;
      },
      error: () => {
        this.toastr.error('Kategoriler yüklenirken hata oluştu', 'Hata');
        this.loading = false;
      }
    });
  }

  save(): void {
    this.submitted = true;
    
    if (!this.categoryForm.valid) {
      this.categoryForm.markAllAsTouched();
      this.toastr.warning('Lütfen gerekli alanları doldurunuz', 'Uyarı');
      return;
    }

    const category: BlogCategory = this.categoryForm.value;

    if (this.editingCategoryId) {
      category.id = this.editingCategoryId;
      // Update işlemi için API endpoint'iniz varsa buraya ekleyin
      this.toastr.info('Kategori güncelleme özelliği henüz eklenmedi', 'Bilgi');
    } else {
      this.blogService.createCategory(category).subscribe({
        next: () => {
          this.toastr.success('Kategori başarıyla oluşturuldu', 'Başarılı');
          this.resetForm();
          this.loadCategories();
        },
        error: () => {
          this.toastr.error('Kategori oluşturulurken hata oluştu', 'Hata');
          this.submitted = false;
        }
      });
    }
  }

  editCategory(category: BlogCategory): void {
    this.editingCategoryId = category.id;
    this.categoryForm.patchValue({
      name: category.name,
      description: category.description,
      slug: category.slug,
      languageId: category.languageId,
      isActive: category.isActive
    });
  }

  resetForm(): void {
    this.editingCategoryId = null;
    this.submitted = false;
    this.categoryForm.reset();
    this.categoryForm.patchValue({ isActive: true });
    
    const enLang = this.languages.find(l => l.code === 'en');
    if (enLang) {
      this.categoryForm.patchValue({ languageId: enLang.id });
    }
  }

  close(): void {
    this.activeModal.dismiss();
  }

  getLanguageName(languageId: number): string {
    const lang = this.languages.find(l => l.id === languageId);
    return lang ? lang.name : '';
  }
}
